import { default as domainAgentSetting } from './setting/store'

export default {
    domainAgentSetting,
}